export default __webpack_public_path__ + "static/media/section2-7-num3.e56e54c9.png";